import { localStorageService } from "@entrilia/shared/services/storage";

export const REPORT_SELECTOR_SIZE_STORAGE_KEY = "report_selector_popup_size_v1";

export const DEFAULT_WIDTH = 440;
export const MIN_WIDTH = 360;
export const MAX_WIDTH = 800;

export const DEFAULT_HEIGHT = 500;
export const MIN_HEIGHT = 300;
export const MAX_HEIGHT = 700;

export interface ReportSelectorSize {
  widthPx: number;
  heightPx: number;
}

export const clampWidth = (widthPx: number): number => Math.max(MIN_WIDTH, Math.min(MAX_WIDTH, widthPx));
export const clampHeight = (heightPx: number): number => Math.max(MIN_HEIGHT, Math.min(MAX_HEIGHT, heightPx));

export const clampSize = (size: ReportSelectorSize): ReportSelectorSize => ({
  widthPx: clampWidth(size.widthPx),
  heightPx: clampHeight(size.heightPx),
});

const isValidSize = (value: unknown): value is ReportSelectorSize => {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const { widthPx, heightPx } = value as Partial<ReportSelectorSize>;
  return (
    typeof widthPx === "number" && Number.isFinite(widthPx) && typeof heightPx === "number" && Number.isFinite(heightPx)
  );
};

const get = (): ReportSelectorSize | undefined => {
  try {
    const stored = localStorageService.getItem<ReportSelectorSize>(REPORT_SELECTOR_SIZE_STORAGE_KEY);
    return isValidSize(stored) ? stored : undefined;
  } catch {
    return undefined;
  }
};

const save = (size: ReportSelectorSize): void => {
  try {
    localStorageService.setItem(REPORT_SELECTOR_SIZE_STORAGE_KEY, clampSize(size));
  } catch {
    // Intentionally ignored to avoid breaking the UI.
  }
};

export const reportSelectorSizeStorage = {
  get,
  save,
};
